class OSFPreviewSectionHover {
    $element   = null;
    $button    = null;
    $highlight = null;
    customizer = null;
    position   = null;

    static instance;

    static getInstance() {
        if (!OSFPreviewSectionHover.instance) {
            OSFPreviewSectionHover.instance = new OSFPreviewSectionHover();
        }
        return OSFPreviewSectionHover.instance;
    }

    constructor() {
        this.initButton();
        let $document = $(document);
        for (let selector in otfCustomizerButtons) {
            $document.on('mouseover', `${selector}`, (event) => {
                event.stopPropagation();
                if(event.currentTarget.tagName === 'HTML'){
                    $('body').addClass('otf-highlight-body');
                    this.initButtonBody(otfCustomizerButtons[selector]);
                }else{
                    $('body').removeClass('otf-highlight-body');
                    this.$element   = $(event.currentTarget);
                    this.customizer = otfCustomizerButtons[selector];
                    this.setPosition();
                }
            })
        }

        $(window).scroll(() => {
            this.setPosition();
        }).resize(() => {
            this.setPosition();
        })
    }

    initButtonBody(data){
        for (let button of data) {
            $('.otf-customize-highlight-body').find(`.otf-button-${button.icon}`)
                .show()
                .data('id', button.id)
                .data('type', button.type)
                .data('trigger', button.trigger)
        }
    }

    setPosition() {
        if (!this.$element) {
            return;
        }
        this.position = this.$element.get(0).getBoundingClientRect();
        this.$highlight.css({
            width   : this.position.width,
            height  : this.position.height,
            display : 'block',
            position: 'fixed',
            left    : this.position.left,
            top     : this.position.top,
            //background: 'red'
        });
        if (this.position.top <= 0 && (this.position.top + this.position.height) > 20) {
            this.$button.css({
                marginTop: this.position.top * -1 + 20,
            })
        } else {
            this.$button.attr('style', '');
        }
        this.setupButton();
    }

    initButton() {
        this.$highlight = $(`<div class="otf-customize-highlight" style="display: none;">
    <div class="button-customize-group">
         <span class="customize-partial-edit-shortcut">
            <button class="customize-partial-edit-shortcut-button otf-button-customizer otf-button-layout">
                ${this.getIconLayout()}
            </button>
        </span>
        <span class="customize-partial-edit-shortcut">
            <button class="customize-partial-edit-shortcut-button otf-button-customizer otf-button-color">
                ${this.getIconColor()}
            </button>
        </span>
        <span class="customize-partial-edit-shortcut">
            <button class="customize-partial-edit-shortcut-button otf-button-customizer otf-button-typography">
                ${this.getIconTypography()}
            </button>
        </span>
        <span class="customize-partial-edit-shortcut">
            <button class="customize-partial-edit-shortcut-button otf-button-customizer otf-button-animation">
                ${this.getIconAnimation()}
            </button>
        </span>
        <span class="customize-partial-edit-shortcut">
            <button class="customize-partial-edit-shortcut-button otf-button-customizer otf-button-default">
                ${this.getIconDefault()}
            </button>
        </span>
    </div>
</div>`);
        this.$highlight.appendTo('body');
        this.$button = this.$highlight.find('button');

        let $buttonBody = this.$highlight.clone();
        $buttonBody.removeClass('otf-customize-highlight').addClass('otf-customize-highlight-body');
        $buttonBody.appendTo('body');
        $buttonBody.on('click', 'button', (event) => {
            let $button = $(event.currentTarget);
            let id      = $button.data('id');
            let type    = $button.data('type');
            let trigger = $button.data('trigger');
            wp.customize.preview.send('preview-move', {
                type   : type,
                id     : id,
                trigger: trigger
            });
        });


        this.$highlight.on('click', 'button', (event) => {
            let $button = $(event.currentTarget);
            let id      = $button.data('id');
            let type    = $button.data('type');
            let trigger = $button.data('trigger');
            wp.customize.preview.send('preview-move', {
                type   : type,
                id     : id,
                trigger: trigger
            });
        });
    }

    setupButton() {
        this.$button.addClass('hide');
        if (typeof this.customizer === 'object' && this.customizer) {
            for (let button of this.customizer) {
                this.setDataButton(`.otf-button-${button.icon}`, button);
            }
        }
    }

    setDataButton(className, button) {
        this.$highlight.find(className)
            .removeClass('hide')
            .data('id', button.id)
            .data('type', button.type)
            .data('trigger', button.trigger)
    }

    getIconDefault() {
        return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
<path d="M13.89 3.39l2.71 2.72c.46.46.42 1.24.03 1.64l-8.01 8.02-5.56 1.16 1.16-5.58s7.6-7.63 7.99-8.03c.39-.39 1.22-.39 1.68.07zm-2.73 2.79l-5.59 5.61 1.11 1.11 5.54-5.65zm-2.97 8.23l5.58-5.6-1.07-1.08-5.59 5.6z"></path>
</svg>`;
    }

    getIconColor() {
        return `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 469.333 469.333" style="min-width: 17px;width: 17px;">
<path d="M401.781,0c-21.156,0-41.365,10.104-54.24,27.292l-78.906,112.302c-8.417,11.24-26.771,12.542-36.677,2.615
l-22.167-22.167c-8.625-8.625-20.094-13.375-32.292-13.375h-3c-12.198,0-23.667,4.75-32.292,13.375l-32.417,32.417
c-4.167,4.167-4.167,10.917,0,15.083l1.833,1.833L12.5,268.5C4.437,276.562,0,287.271,0,298.667s4.438,22.104,12.5,30.167
l16.385,16.396c3.354,3.365,8.573,4.104,12.719,1.781l37.604-20.885l-20.885,37.604c-2.313,4.156-1.583,9.354,1.781,12.719
l80.396,80.385c8.063,8.063,18.771,12.5,30.167,12.5s22.104-4.438,30.167-12.5l99.125-99.125l1.833,1.833
c2.083,2.083,4.813,3.125,7.542,3.125c2.729,0,5.458-1.042,7.542-3.125l32.417-32.417c8.625-8.625,13.375-20.094,13.375-32.292
v-3c0-12.198-4.75-23.667-13.375-32.292l-22.167-22.167c-4.531-4.531-7.125-10.802-7.125-17.208
c0-7.615,3.635-14.896,9.469-19.271l112.833-79.302c16.927-12.677,27.031-32.885,27.031-54.042
C469.333,30.302,439.031,0,401.781,0z M185.75,441.75c-8.063,8.063-22.104,8.063-30.167,0l-74.708-74.698l35.115-63.208
c2.313-4.156,1.583-9.354-1.781-12.719c-3.375-3.365-8.573-4.104-12.719-1.781l-63.208,35.115L27.583,313.75
c-4.031-4.031-6.25-9.385-6.25-15.083s2.219-11.052,6.25-15.083l99.125-99.125l158.167,158.167L185.75,441.75z M429.771,104.333
l-112.844,79.302c-11.438,8.583-18.26,22.24-18.26,36.531c0,12.198,4.75,23.667,13.375,32.292l22.167,22.167
c4.531,4.531,7.125,10.802,7.125,17.208v3c0,6.406-2.594,12.677-7.125,17.208l-24.875,24.875L132.417,160l24.875-24.875
c4.531-4.531,10.802-7.125,17.208-7.125h3c6.406,0,12.677,2.594,17.208,7.125l22.167,22.167
c18.729,18.729,52.75,16.542,69.021-5.156l78.906-112.313c8.677-11.573,22.5-18.49,36.979-18.49
c25.49,0,46.219,20.729,46.219,46.219C448,82.031,441.083,95.854,429.771,104.333z"/>
<path d="M405.333,42.667C393.573,42.667,384,52.24,384,64c0,11.76,9.573,21.333,21.333,21.333S426.667,75.76,426.667,64
C426.667,52.24,417.094,42.667,405.333,42.667z"/>
</svg>`;
    }

    getIconLayout() {
        return `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512.001 512.001" style="min-width: 17px;width: 17px;">
<path d="M512,256.001c0-10.821-6.012-20.551-15.694-25.398l-38.122-19.061l38.122-19.06c0.001-0.001,0.004-0.002,0.004-0.002
c9.68-4.845,15.692-14.576,15.692-25.397c0-10.819-6.013-20.55-15.694-25.397L281.09,34.08
c-15.712-7.849-34.47-7.849-50.185,0.001L15.691,141.691C6.013,146.534,0,156.264,0,167.084c0,10.821,6.012,20.551,15.694,25.398
l38.121,19.06l-38.126,19.063C6.012,235.45,0,245.18,0,256.001s6.012,20.551,15.694,25.397l38.121,19.061l-38.118,19.059
C6.02,324.353,0.004,334.08,0,344.902c-0.004,10.828,6.008,20.564,15.694,25.412l215.215,107.608
c7.856,3.925,16.471,5.886,25.09,5.886c8.619,0,17.238-1.963,25.095-5.887l215.215-107.608
c9.682-4.845,15.695-14.582,15.691-25.41c-0.004-10.822-6.02-20.549-15.694-25.381l-38.122-19.061l38.126-19.063
C505.988,276.552,512,266.822,512,256.001z M26.225,171.431c-2.339-1.171-2.687-3.226-2.687-4.346s0.35-3.175,2.683-4.343
L241.429,55.138c4.563-2.28,9.568-3.418,14.573-3.418c5.003,0,10.007,1.139,14.567,3.417L485.776,162.74
c2.337,1.17,2.687,3.225,2.687,4.345s-0.348,3.175-2.687,4.346L270.572,279.032c-9.125,4.558-20.019,4.558-29.139,0.001
L26.225,171.431z M485.783,340.575c2.33,1.164,2.679,3.215,2.679,4.336c0.001,1.123-0.348,3.182-2.683,4.35L270.571,456.865
c-9.125,4.558-20.019,4.559-29.139,0.001L26.225,349.262c-2.339-1.171-2.688-3.229-2.687-4.352c0-1.119,0.348-3.171,2.683-4.337
l53.912-26.956l150.776,75.387c7.856,3.925,16.471,5.886,25.089,5.886c8.619,0,17.238-1.963,25.095-5.887l150.772-75.386
L485.783,340.575z M485.778,260.345L270.571,367.949c-9.125,4.558-20.019,4.559-29.139,0.001L26.225,260.347
c-2.339-1.17-2.687-3.225-2.687-4.345c0-1.122,0.348-3.175,2.683-4.344l53.912-26.956l150.776,75.387
c7.855,3.925,16.472,5.886,25.089,5.886c8.617,0,17.237-1.962,25.094-5.888l150.774-75.386l53.908,26.954
c2.339,1.171,2.687,3.225,2.687,4.346C488.462,257.121,488.113,259.176,485.778,260.345z"/>
</svg>`;
    }

    getIconTypography() {
        return `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21.758 21.758" style="min-width: 15px;width: 15px;">
<path d="M12.485,2.604h5.487v3.207h2.364V0H1.423v5.811h2.365V2.604h5.891v16.79H7.032v2.364h7.936v-2.364
h-2.483V2.604z"/>
</svg>`;
    }

    getIconAnimation(){
        return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style="min-width: 17px;width: 17px;">
<path d="M400.268,175.599c-1.399-3.004-4.412-4.932-7.731-4.932h-101.12l99.797-157.568c1.664-2.628,1.766-5.956,0.265-8.678
C389.977,1.69,387.109,0,384.003,0H247.47c-3.234,0-6.187,1.826-7.637,4.719l-128,256c-1.323,2.637-1.178,5.777,0.375,8.294
c1.562,2.517,4.301,4.053,7.262,4.053h87.748l-95.616,227.089c-1.63,3.883-0.179,8.388,3.413,10.59
c1.382,0.845,2.918,1.254,4.446,1.254c2.449,0,4.864-1.05,6.537-3.029l273.067-324.267
C401.206,182.161,401.667,178.611,400.268,175.599z"/>
</svg>`;
    }
}

OSFPreviewSectionHover.getInstance();